import React from "react";
import { BRAND } from "../lib/constants";
import { BRAND_LOGO_API } from "../lib/api";

export function formatLongDate(s) {
  if (!s) return "—";
  try {
    // For YYYY-MM-DD (date-only, no time), construct the Date in LOCAL time
    // so the displayed day matches what the coach typed. `new Date("2026-05-
    // 15")` parses as UTC midnight, which renders as May 14 in any timezone
    // west of UTC. Date-time strings (with "T" / "Z") parse normally.
    const m = typeof s === "string" && /^(\d{4})-(\d{2})-(\d{2})$/.exec(s);
    const d = m
      ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]))
      : new Date(s);
    return d.toLocaleDateString(undefined, {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  } catch {
    return s;
  }
}

/**
 * BrandBanner — navy banner used at the top of every printable / PDF report page.
 * Provide one of:
 *   - athleteName + testDate (default headline = "Personalised Lactate Testing Report")
 *   - athleteName + dateRange + headline (for the compare report)
 */
export function BrandBanner({
  athleteName,
  testDate,
  dateRange,
  headline = "Personalised Lactate Testing Report",
}) {
  return (
    <div className="tir-banner px-10 py-7 flex items-center justify-between gap-8">
      <div className="flex items-center gap-5 min-w-0 flex-1">
        <img
          src={BRAND_LOGO_API}
          alt={`${BRAND.name} logo`}
          crossOrigin="anonymous"
          className="h-16 w-auto object-contain flex-shrink-0"
          data-testid="report-logo"
        />
        <div className="min-w-0">
          <div className="text-[10px] tracking-[0.35em] uppercase text-white/70">{BRAND.name}</div>
          <div className="font-serif-display text-2xl mt-1 text-white leading-tight">
            {headline}
          </div>
        </div>
      </div>
      <div className="text-right min-w-0 flex-shrink-0 max-w-[40%]">
        <div className="text-[10px] tracking-[0.3em] uppercase text-white/70">Athlete</div>
        <div className="font-serif-display text-xl text-white leading-tight break-words">
          {athleteName}
        </div>
        <div className="text-[11px] tracking-[0.25em] uppercase text-white/70 mt-1.5">
          {dateRange ? dateRange : formatLongDate(testDate)}
        </div>
      </div>
    </div>
  );
}

export function BrandFooter() {
  return (
    <div className="absolute bottom-0 left-0 right-0 px-10 py-4 border-t border-[var(--tir-border)] flex items-center justify-between text-[10px] tracking-[0.28em] uppercase text-[var(--tir-muted)]">
      <span>{BRAND.name}</span>
      <span>{BRAND.website}</span>
    </div>
  );
}
